import React from "react";
import { Card } from "react-bootstrap";
import "./index.scss";
export const Interventions = ({ description, prestations, title }) => {
  return (
    <div className="realisation mt-5 mb-5">
      <div className="realisation-header">
        <div className="realisation-title">{title}</div>
        <div className="realisation-subtitle mt-3 mb-5">{description}</div>
        <div className="row ms-0  gx-0 w-100  mb-5  justify-content-center  align-items-center">
          {prestations.map((prestation, index) => (
            <div className="col-xxl-3 col-lg-4 col-md-6 col-12 ">
              <div className="thermal-card">
                <div className="text-box">
                  <h5>{prestation.text}</h5>
                </div>
                <Card.Img
                  variant="bottom"
                  src={prestation.icon}
                  alt="Étude thermique"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
